/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Ifyouneedhelpinthem6Inputs */

const en_help_ifyouneedhelpinthem6 = /** @type {(inputs: Help_Ifyouneedhelpinthem6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you need help in the meantime, feel free to reach out to`)
};

/**
* | output |
* | --- |
* | "If you need help in the meantime, feel free to reach out to" |
*
* @param {Help_Ifyouneedhelpinthem6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const help_ifyouneedhelpinthem6 = /** @type {((inputs?: Help_Ifyouneedhelpinthem6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Ifyouneedhelpinthem6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_ifyouneedhelpinthem6(inputs)
});
export { help_ifyouneedhelpinthem6 as "help_ifYouNeedHelpInTheM" }